import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { postRequest } from '../../helpers/apiHandler';
import { showAlert } from '../../store/actions/alertAction';

const TemplateList = (props) => {
  const dispatch = useDispatch();
  const { phoneNumberId, wabaId } = props;
  const { access_token } = useSelector((state) => state.auth.user);
  const [templates, setTemplates] = useState([]);
  const [paging, setPaging] = useState({ before: '', after: '', next: '', previous: '' });

  useEffect(() => {
    postRequest(
      '/v2/whatsapp/get-phone-templates',
      { phone_number_id: phoneNumberId, waba_id: wabaId },
      access_token.token,
      (res) => {
        if (res.success) {
          const { data } = res.data;
          setTemplates(data.data);
          setPaging(data.paging);
        } else {
          console.error('Error fetching phone templates:', res.message);
          dispatch(
            showAlert('Error while fetching phone templates. Please try again later.', 'danger')
          );
        }
      }
    );
  }, [phoneNumberId, wabaId, access_token.token, dispatch]);

  const columns = [
    {
      id: 'fixed-left',
      name: 'Template ID',
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: 'Template Name',
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: 'Language',
      selector: (row) => row.language,
      sortable: true,
    },
    {
      name: 'Status',
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => {
        let badgeColor = 'danger';

        if (row.status === 'APPROVED') {
          badgeColor = 'success';
        } else if (row.status === 'PENDING') {
          badgeColor = 'warning';
        }

        return <span className={`badge bg-${badgeColor}`}>{row.status}</span>;
      },
    },
    {
      name: 'Category',
      selector: (row) => {
        return row.sub_category ? `${row.category} • ${row.sub_category}` : row.category;
      },
      sortable: true,
    },
    {
      name: 'Actions',
      selector: (row) => {
        return (
          <div className="d-flex justify-content-center align-items-center gap-1">
            <Button
              as={Link}
              to={`/dashboard/whatsapp/phone-number-details/${wabaId}/${phoneNumberId}/templates/${row.id}`}
            >
              Show Detail
            </Button>
          </div>
        );
      },
    },
  ];

  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
          <h5 className="card-title">Templates</h5>
          <Button
            as={Link}
            variant="primary"
            style={{ minWidth: 160 }}
            to={`/dashboard/whatsapp/phone-number-details/${wabaId}/${phoneNumberId}/templates/create`}
          >
            Add New Template
          </Button>
        </div>
        <DataTable
          columns={columns}
          data={templates}
          progressPending={false}
          paginationComponentOptions={{
            rowsPerPageText: 'Items per page:',
          }}
          pagination
        />
      </div>
    </div>
  );
};

export default TemplateList;
